module.exports = {
  "brightfit-redirect": {
    "url": `${process.env.REACT_APP_API_PREFIX}/brightfit-redirect`,
    "callback": "api/brightfit-redirect"
  },
};
